var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2"},[_c('px-aprovacao-solicitacao-produtos-table',{attrs:{"aprovacao":_vm.aprovacao},on:{"update":_vm.emitUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }